<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação da ação de remover produto</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body" v-if="removesFromMarketplace">
        Remover o produto fará com que ele seja removido do Placemarket e do Marketplace. Em caso de o marketplace rejeitar a ação, a remoção será abortada.
      </div>
      <div class="c-modalCard__body" v-else>
        Remover o produto fará com que ele seja retirado apenas do Placemarket da Moovin, mas não surtirá nenhuma alteração no produto no marketplace, ao realizar este processo poderá anunciar o produto novamente, mas o mesmo não receberá atualizações de estoque e preço durante o processo, certifique-se de deletar o anúncio diretamente no marketplace.
      </div>

      <div class="c-modalCard__body">
        Tem certeza de que deseja remover o produto {{ productInText }}?
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      product: {
        type: Object,
        required: false
      },
      typeAction: {
        type: String,
        required: false
      },
      module: {
        type: Object,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('confirm', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    computed: {
      productInText () {
        if (this.product === null) {
          return null
        }

        return `'${this.product.title}'`
      },
      removesFromMarketplace () {
        const marketplaces = ['comfortflex', 'decathlon', 'keepRunning', 'maisCorreios', 'polishop', 'privalia', 'ramarim', 'sicoob', 'sicredi']

        return this.module && marketplaces.includes(this.module.identifier)
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalRemoveProduct.vue?20594aef